import AdminHeader from "components/Headers/AdminHeader";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Button,
  Badge,
  Container,
  Row,
  Col,
  Card,
  Input,
  CardHeader,
  CardBody,
  UncontrolledTooltip,
} from "reactstrap";
import Select, { components } from "react-select";

import CommonTable from "components/CommonComponents/ReactTable/Table";
import {
  fixedWidthCustomStyle,
  DEFAULT_RECORDS_PER_PAGE,
} from "constants/CommonConstants";
import { STATUS_OPTIONS } from "components/constant";
import { urlEncodedId } from "components/CommonComponents/encodeDecodeFunction";
import {
  ISOToHumanReadableDate,
  showAlert,
} from "components/CommonComponents/CommonFunctions";
import { instructorsList } from "components/constant";

//courses list
export const coursesList = [
  { ID: 1, name: "Electrical Safety" },
  { ID: 2, name: "Power Systems" },
  { ID: 3, name: "Industrial Wiring Advanced" },
  { ID: 4, name: "Substation Operations" },
  { ID: 5, name: "Energy Management Basics" },
  { ID: 6, name: "Underground Cabling" },
  { ID: 7, name: "Electrical Safety Advanced" },
  { ID: 8, name: "Transformer Maintenance" },
  { ID: 9, name: "Panel Wiring" },
  { ID: 10, name: "Power Systems Advanced" },
];

/* COMPONENT  */
const Instructors = () => {
  const authData = JSON.parse(localStorage.getItem("p") || "{}");
  const role = authData?.role;
  const navigate = useNavigate();
  const [pageNum, setPageNum] = useState(1);
  const [filterState, setFilterState] = useState({
    searchName: "",
    searchEmail: "",
    searchMobile: "",
    searchManufacturer: null,
    searchStatus: null,
    filterParams: [],
  });

  const columns = [
    {
      Header: "Sr. No.",
      accessor: "id",
    },
    {
      Header: "Name",
      accessor: "fullName",
    },
    {
      Header: "Email",
      accessor: "email",
      Cell: ({ value }) => value || "N/A",
    },
    {
      Header: "Mobile No",
      accessor: "phone",
    },
    {
      Header: "Experience",
      accessor: "experienceYears",
      Cell: ({ value }) => `${value} yrs`,
    },
    {
      Header: "Status",
      accessor: "status",
      Cell: ({ value }) => (
        <Badge color={value === "ACTIVE" ? "success" : "warning"} pill>
          {value}
        </Badge>
      ),
    },
    {
      Header: "Registered On",
      accessor: "createdOn",
      Cell: ({ value }) => (value ? ISOToHumanReadableDate(value) : "-"),
    },
    {
      Header: "Actions",
      disableSortBy: true,
      Cell: ({ row }) => {
        const id = row.original.id;
        const encodedId = urlEncodedId(row.original.id);
        const isActive = row.original.status === "ACTIVE";

        return (
          <div className="d-flex gap-2">
            <Button
              className="btn-link d-flex align-items-center p-0"
              id={`details${encodedId}`}
              size="sm"
              onClick={() => {
                navigate(
                  role === "SUPER_ADMIN"
                    ? `/super-admin/instructor/${encodedId}/details`
                    : `/admin/instructor/${encodedId}/details`,
                );
              }}
            >
              <i className="fas fa-eye mr-1 table-action-primary" />
              {/* View */}
            </Button>
            <UncontrolledTooltip target={`details${encodedId}`}>
              View
            </UncontrolledTooltip>

            <Button
              className="btn-link d-flex align-items-center p-0"
              id={`edit${encodedId}`}
              size="sm"
              onClick={(e) => {
                e.stopPropagation();
                navigate(
                  role === "SUPER_ADMIN"
                    ? `/super-admin/instructor/add-new`
                    : `/admin/instructor/add-new`,
                  {
                    state: { mode: "edit", instructorData: row.original },
                  },
                );
              }}
            >
              <i className="fas fa-edit mr-1 table-action-info" />
              {/* Edit */}
            </Button>
            <UncontrolledTooltip target={`edit${encodedId}`}>
              Edit
            </UncontrolledTooltip>

            <span className="mr-1 text-muted">|</span>
            <Button
              color="link"
              size="lg"
              className="d-flex align-items-center p-0 ml-1"
              id={`status${encodedId}`}
              onClick={(e) => {
                e.stopPropagation();
                toggleStatus(row.original);
              }}
            >
              {isActive ? (
                <>
                  <i className="fa-regular fa-circle-xmark table-action-delete mr-1" />
                </>
              ) : (
                <>
                  <i className="fa-regular fa-circle-check table-action-success mr-1" />
                </>
              )}
            </Button>
            <UncontrolledTooltip delay={0} target={`status${encodedId}`}>
              {isActive ? "Inactivate" : "Activate"}
            </UncontrolledTooltip>

            {/* <Button
              className="btn-link d-flex align-items-center p-0 table-action-delete"
              id={`delete${id}`}
              size="sm"
              onClick={(e) => {
                e.stopPropagation();
              }}
            >
              <i className="fas fa-trash mx-1 table-action-delete" />
            </Button>
            <UncontrolledTooltip target={`delete${id}`}>
              Delete
            </UncontrolledTooltip> */}
          </div>
        );
      },
    },
  ];

  const toggleStatus = (data) => {
    const isActive = data.status === "ACTIVE";
    const newStatus = isActive ? "INACTIVE" : "ACTIVE ";
    showAlert({
      title: `Are you sure you want to ${
        isActive ? "inactivate" : "activate"
      } this instructor?`,
      message: `Instructor "${data.fullName}" will be marked as ${newStatus.toLowerCase()}.`,
      type: "warning",
      confirmStyle: "deep-blue",
      cancelStyle: "secondary",
      confirmText: "Yes",
      cancelText: "Cancel",
      onConfirm: () => {},
    });
  };
  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      handleSearch();
    }
  };

  const handleSearch = () => {};

  const handleClear = () => {
    setFilterState({
      searchName: "",
      searchEmail: "",
      searchMobile: "",
      searchManufacturer: "",
      searchStatus: null,
      filterParams: [],
    });
    if (pageNum !== 1) setPageNum(1);
  };

  // Custom Option Renderer
  const Option = (props) => {
    return (
      <components.Option {...props}>
        <Badge
          color={props.data.value === "ACTIVE" ? "success" : "warning"}
          pill
        >
          {props.data.label}
        </Badge>
      </components.Option>
    );
  };

  // Custom SingleValue Renderer (for the selected value)
  const SingleValue = (props) => {
    return (
      <components.SingleValue {...props}>
        <Badge
          color={props.data.value === "ACTIVE" ? "success" : "warning"}
          pill
        >
          {props.data.label}
        </Badge>
      </components.SingleValue>
    );
  };

  const handleOnRowClick = (rowData) => {
    const encodedId = urlEncodedId(rowData.id); //rowData.ID
    navigate(
      role === "SUPER_ADMIN"
        ? `/super-admin/instructor/${encodedId}/details`
        : `/admin/instructor/${encodedId}/details`,
    );
  };

  return (
    <>
      <AdminHeader />

      <Container className="mt--6" fluid>
        <Row>
          <Col>
            <Card>
              {/* head */}
              <CardHeader className="d-flex justify-content-between align-items-center">
                <h3 className="mb-0">Trainers</h3>
                <Button
                  className="btn-deep-blue"
                  onClick={() =>
                    navigate(
                      role === "SUPER_ADMIN"
                        ? "/super-admin/instructor/add-new"
                        : "/admin/instructor/add-new",
                      {
                        state: { mode: "add" },
                      },
                    )
                  }
                >
                  <i className="fa fa-plus mr-1" />
                  Trainer
                </Button>
              </CardHeader>

              {/* body */}
              <CardBody>
                <div className="d-flex align-items-center justify-content-between mb-3 flex-wrap flex-column flex-md-row">
                  {/* Left side - Filter Inputs + Search */}
                  <div className="d-flex flex-wrap align-items-center filter-group">
                    <Input
                      type="text"
                      placeholder="Search by name"
                      className="mr-2 mb-2 filter-input-large"
                      value={filterState.searchName}
                      onChange={(e) =>
                        setFilterState((prev) => ({
                          ...prev,
                          searchName: e.target.value,
                        }))
                      }
                      onKeyDown={handleKeyDown}
                    />

                    <Input
                      type="text"
                      placeholder="Search by email"
                      className="mr-2 mb-2 filter-input-large"
                      value={filterState.searchEmail}
                      onChange={(e) =>
                        setFilterState((prev) => ({
                          ...prev,
                          searchEmail: e.target.value,
                        }))
                      }
                      onKeyDown={handleKeyDown}
                    />

                    <Input
                      type="text"
                      placeholder="Search by mobile no."
                      className="mr-2 mb-2 filter-input-large"
                      value={filterState.searchMobile}
                      onChange={(e) =>
                        setFilterState((prev) => ({
                          ...prev,
                          searchMobile: e.target.value,
                        }))
                      }
                      onKeyDown={handleKeyDown}
                    />

                    <Select
                      className="mr-2 mb-2 filter-select"
                      options={STATUS_OPTIONS}
                      placeholder="Status"
                      value={filterState.searchStatus}
                      onChange={(selected) =>
                        setFilterState((prev) => ({
                          ...prev,
                          searchStatus: selected,
                        }))
                      }
                      classNamePrefix="react-select"
                      styles={fixedWidthCustomStyle()}
                      components={{ Option, SingleValue }}
                      onKeyDown={handleKeyDown}
                      // isClearable
                    />

                    <Button
                      color="default"
                      className="d-flex align-items-center mb-2 filter-btn btn-deep-blue"
                      onClick={handleSearch}
                    >
                      <i className="fa fa-search mr-1" />
                      Search
                    </Button>

                    {Object.keys(filterState.filterParams).length > 0 && (
                      <Button
                        color="default"
                        className="ml-2 mb-0 filter-btn btn-simple"
                        onClick={handleClear}
                      >
                        <i className="fa fa-times mr-1" /> Clear
                      </Button>
                    )}
                  </div>
                </div>
                <div className="mt-2 mb-3 mx-1">
                  {instructorsList.length ? (
                    <span className="total-records">
                      Total Records : {instructorsList.length}
                    </span>
                  ) : null}
                </div>

                <CommonTable
                  columns={columns}
                  data={instructorsList.slice(
                    (pageNum - 1) * (DEFAULT_RECORDS_PER_PAGE || 10),
                    pageNum * (DEFAULT_RECORDS_PER_PAGE || 10),
                  )}
                  defaultPageSize={DEFAULT_RECORDS_PER_PAGE || 10}
                  activePage={pageNum}
                  setPageNum={setPageNum}
                  totalPages={Math.ceil(
                    instructorsList.length / DEFAULT_RECORDS_PER_PAGE,
                  )}
                  showPaginationBottom={true}
                  rowClick={handleOnRowClick}
                />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default Instructors;
